export type PageTypes =
  | 'homepage'
  | 'landingPage'
  | 'search'
  | 'booking'
  | 'bookingCheck'
  | 'bookingConfirmation'
  | 'imprint'
  | 'privacy'
  | 'your_benefits'
  | 'contact'
  | 'host'
  | 'reviewsNew'
  | 'reviewsConfirmation';

export const HOMEPAGE: PageTypes = 'homepage';
export const LANDING_PAGE: PageTypes = 'landingPage';
export const SEARCH: PageTypes = 'search';
export const BOOKING: PageTypes = 'booking';
export const BOOKING_CHECK: PageTypes = 'bookingCheck';
export const BOOKING_CONFIRMATION: PageTypes = 'bookingConfirmation';
export const ABOUT: PageTypes = 'your_benefits';
export const CONTACT: PageTypes = 'contact';
export const HOST: PageTypes = 'host';
export const REVIEWS_NEW: PageTypes = 'reviewsNew';
export const REVIEWS_SUCCESS: PageTypes = 'reviewsConfirmation';
